import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable()
export class HomeService {
  constructor(private http: HttpClient) {
  }

  getHome() {
    return this.http.get(`${API_URL}/api/home`);
  }

  getApiService(url) {
    return this.http.get(url);
  }

  public extractData(res: any) {
    const body = res.hasOwnProperty('items') ? res.items : res;
    return body || {};
  }
}
